// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Zj","image":"_j","imageNoBackground":"ak"};